import { axiosConfig } from './axios-config.js'

export const order = {
  // 取得訂單
  get: (id, token) => axiosConfig.get(`/api/console/order/${id}`, token)
}
